import React, { Dispatch, SetStateAction, useState } from 'react';
import { InputMui } from '../../../../../../components/input-mui/input-mui';
import { DialogValuePicker } from '../../../../../../components/dialog-value-picker';

type InputStringProps = {
  value: string;
  label: string;
  setValue: (val: string) => void | Dispatch<SetStateAction<string>>;
  inputType?: string;
  step?: number;
  min?: number;
  max?: number;
  percentValue?: boolean;
};

export const InputString: React.FC<InputStringProps> = ({
  value,
  label,
  setValue,
  inputType,
  step,
  max,
  min,
  percentValue,
}) => {
  const [showPicker, setShowPicker] = useState<boolean>(false);

  const handleSetValue = (e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value);

  return (
    <>
      <InputMui
        value={value}
        label={label}
        {...(inputType ? { type: inputType } : {})}
        {...(step ? { step } : {})}
        {...(!percentValue ? { onChange: handleSetValue } : { onClickInput: () => setShowPicker(true) })}
        min={min}
        max={max}
      />
      {percentValue && (
        <DialogValuePicker
          open={showPicker}
          setOpen={setShowPicker}
          title={label}
          onSave={(value) => setValue(value.toString())}
          value={parseInt(value)}
          unit="%"
          {...(max ? { max } : {})}
        />
      )}
    </>
  );
};
